/**
 * External dependencies
 */
import { get } from 'lodash';

export const getLocationWebsiteId = state => get(state, 'ui.locationWebsiteModal.locationWebsiteId', "");